import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  container: {
    marginTop: "16px",
  },
  button: {
    borderRadius: "19px",
  },
  root: { position: "relative" },
  buttonModal: {
    borderRadius: "19px",
    position: "absolute",
    color: "white",
    left: 16,
    top: 65,
  },
  containerModal: {
    width: "100%",
    textAlign: "center",
    height: "100%",
    alignContent: "center",
  },
});

export default useStyles;
